import request from '@/utils/request'
export const url = 'https://aitools.x-l.xin/web/admin'
export const loginQrCodeUrl = `${url}/class/user_loginQrCode.cls.php`
export const requestUrl = url

/**
 * @typedef Response 响应结果
 * @property {-1|0|1} code 响应状态码 -1 登录过期, 0 请求正常, 1 请求有误
 * @property {string} msg 请求结果描述
 * @property {undefined|Record<string, unknown>|Record<string, unknown>[]} data 请求结果内容
 */

/**
 * @typedef DefaultOptions
 * @property {string} method
 * @property {string} url
 */

/**
 * @param {object} query 请求参数
 * @param {boolean} [carryToken] 请求是否携带Token, 默认为 true
 * @param {(options:DefaultOptions) => DefaultOptions} [afterParseOptions] 解析配置后的 hook, 返回值将替换原解析后的配置
 * @returns {Promise<Response>}
 */
export function fetchData(query, carryToken = true, afterParseOptions) {
	if (!query?.url) {
		throw new Error('url 参数不能为空')
	}
	const baseUrl = url.endsWith('/') ? url.slice(0, -1) : url
	let token = sessionStorage.getItem('Token') ?? ''
	if (token === 'undefined') {
		token = ''
	}
	const targetUrl = `${baseUrl}/class${query.url.startsWith('/') ? query.url : `/${query.url}`}${carryToken ? `?Token=${token}` : ''}`

	let options = {
		method: 'POST',
		...query,
		url: targetUrl,
		headers: {
			'Content-Type': 'application/json'
		}
	}

	if (afterParseOptions) {
		options = afterParseOptions(options)
	}

	return request(options)
}

// 接口调起
/**
 * @param {object} query 请求参数
 * @param {boolean} [carryToken] 请求是否携带Token, 默认为 true
 * @param {(options:DefaultOptions) => DefaultOptions} [afterParseOptions] 解析配置后的 hook, 返回值将替换原解析后的配置
 * @returns {Promise<Response>}
 */
export function fetchDataApi(query, carryToken = true, afterParseOptions) {
	if (!query?.url) {
		throw new Error('url 参数不能为空')
	}
	const baseUrl = url.endsWith('/') ? url.slice(0, -1) : url
	let token = sessionStorage.getItem('Token') ?? ''
	if (token === 'undefined') {
		token = ''
	}
	const targetUrl = `${baseUrl}/class${query.url.startsWith('/') ? query.url : `/${query.url}`}${carryToken ? `?Token=${token}` : ''}`

	let options = {
		method: 'POST',
		...query,
		url: targetUrl,
		headers: {
			'Content-Type': 'application/json'
		}
	}

	if (afterParseOptions) {
		options = afterParseOptions(options)
	}

	return request(options)
}


/**
 * 上传OSS
 * @type {import('@/types/UpLoadToOss').UpLoadToOss}
 */
export const upLoadToOss = (tokenInfo, file, filename, options = {}) => {
	const uploadConf = {
		accessKeyId: tokenInfo.OSSAccessKeyId,
		accessKeySecret: tokenInfo.signature,
		stsToken: tokenInfo.SecurityToken,
		endpoint: tokenInfo.url,
		bucket: tokenInfo.bucket
	}
	const type = String(file.type).trim()

	const ossOptions = options.ossOptions || {}
	const downloadName = (() => {
		if (!options.downloadName) return ''
		const name = encodeURIComponent(options.downloadName).replace(/'/g, '%27') + getSuffix(filename)
		return `filename="${name}"; filename*="${name}";`
	})()

	return ossClient(uploadConf).put(`${tokenInfo.sub}/${filename}`, file, {
		headers: {
			'Content-Type': type,
			'Content-Disposition': `attachment; ${downloadName}`
		},
		...ossOptions
	})
}

